import * as _ from 'lodash';

import { Injectable } from '@angular/core';

import { ApiModel } from 'models';
import { Observable, of } from 'rxjs';
import { BrandShopConfig } from './brand-shop-config.types';
import { catchError } from 'rxjs/operators';
import { ReorderSortBy, SortOrder } from 'services/product-search/searcher.types';

@Injectable()
export class BrandShopConfigService {
    constructor(private apiModel: ApiModel) {}

    public getBrandShopConfig(brandId: string): Observable<BrandShopConfig> {
        const defaultConfig = {
            filters: _.values(BrandShopDefaultFilters).map((filterKey) => ({ key: filterKey })),
            defaultSortingCriteria: { sortBy: ReorderSortBy.StockRatio, sortOrder: SortOrder.DESC },
            internalUsage: { showDynamicCategories: true }
        };

        if (!brandId) {
            return of(defaultConfig as BrandShopConfig);
        }

        const url = `${this.apiModel.getReorderEndpoint()}/brandShop/${brandId}/config`;
        return this.apiModel
            .makeHttpObservableRequest({ method: 'GET', url })
            .pipe(catchError(() => of(defaultConfig)));
    }
}

enum BrandShopDefaultFilters {
    SEASON = 'season',
    TARGET_GROUP = 'target_group',
    COLOR = 'color',
    AGE_GROUP = 'age_group',
    DISCOUNT = 'discount',
    SIZE = 'size',
    MINIMUM_STOCK = 'minimum_stock'
}
